// extracted by mini-css-extract-plugin
module.exports = {"feedbackSubtitle":"style-module_feedbackSubtitle__2_3rnweJG6AOC5REt9PeIf"};